import React, { forwardRef, useEffect, useRef, useState } from 'react';
import {
  ContentState,
  // Editor, ==>p lugin
  EditorState,
  RichUtils,
  AtomicBlockUtils,
  DraftEditorCommand,
  convertToRaw,
  convertFromRaw,
  convertFromHTML,
  CompositeDecorator,
  getSafeBodyFromHTML,
  DraftDecoratorComponentProps,
  DefaultDraftBlockRenderMap,
} from 'draft-js';
import Editor, { composeDecorators } from '@draft-js-plugins/editor';
// import { Map } from 'immutable';

import 'draft-js/dist/Draft.css';
// import { Editor } from 'react-draft-wysiwyg';
import draftjsToHtml from 'draftjs-to-html';
// import htmlToDraftJs from 'html-to-draftjs'; // don't use
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import '@draft-js-plugins/image/lib/plugin.css';
// ----------------------------------------------------------------------------------------------------------
import { Button, message } from 'antd';
import ImageModal from './atoms/image_modal';
// ----------------------------------------------------------------------------------------------------------
//https://www.draft-js-plugins.com/plugin/image
import createImagePlugin from '@draft-js-plugins/image';
import createResizeablePlugin from '@draft-js-plugins/resizeable';
import createFocusPlugin from '@draft-js-plugins/focus';
import createBlockDndPlugin from '@draft-js-plugins/drag-n-drop';

const resizeablePlugin = createResizeablePlugin({
  vertical: 'relative',
  horizontal: 'relative',
});
const focusPlugin = createFocusPlugin();
const blockDndPlugin = createBlockDndPlugin();
const imgDecorator = composeDecorators(
  resizeablePlugin.decorator,
  focusPlugin.decorator,
  blockDndPlugin.decorator
);
const imagePlugin = createImagePlugin({ decorator: imgDecorator });
// ----------------------------------------------------------------------------------------------------------

const BaseEditor = (props) => {
  // const { html, setHtml, readonly, style, editorStyle, ...rest } = props;
  const {
    html,
    images = [],
    setContents,
    readonly,
    style,
    setGModal,
    ...rest
  } = props;

  const editRef = useRef();
  // ----------------------------------------------------------------------------------------------------
  // linkDecorator

  const Link = (props) => {
    const { url } = props.contentState.getEntity(props.entityKey).getData();
    return (
      <a rel="noopener noreferrer" target="_blank" href={url}>
        {props.children}
      </a>
    );
  };

  const linkDecorator = new CompositeDecorator([
    {
      strategy: (contentBlock, callback, contentState) => {
        contentBlock.findEntityRanges((character) => {
          const entityKey = character.getEntity();
          return (
            entityKey !== null &&
            contentState.getEntity(entityKey).getType() === 'LINK'
          );
        }, callback);
      },
      component: Link,
    },
  ]);

  // ----------------------------------------------------------------------------------------------------
  // editor
  // case 1
  // const [editorState, setEditorState] = useState(EditorState.createEmpty());
  // case 2
  const blocksFromHTML = convertFromHTML(
    html || '<div>내용을 작성해주세요.</div>',
    // ? `<div>${html}</div><img src="https://raw.githubusercontent.com/facebook/draft-js/master/examples/draft-0-10-0/convertFromHTML/image.png" />`
    getSafeBodyFromHTML,
    DefaultDraftBlockRenderMap
  );
  const [editorState, setEditorState] = useState(
    EditorState.createWithContent(
      ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      ),
      linkDecorator
    )
  );
  // ----------------------------------------------------------------------------------------------------------
  //
  // https://raw.githubusercontent.com/facebook/draft-js/master/examples/draft-0-10-0/convertFromHTML/image.png

  const CustomContentStateConverter = (contentState) => {
    // Correctly assign properties to images and links
    const newBlockMap = contentState.getBlockMap().map((block) => {
      const entityKey = block.getEntityAt(0);
      if (entityKey !== null) {
        const entityBlock = contentState.getEntity(entityKey);
        const entityType = entityBlock.getType();
        switch (entityType) {
          case 'IMAGE': {
            const newBlock = block.merge({
              type: 'atomic',
              text: 'img',
            });
            // const newContentState = contentState.mergeEntityData(entityKey, { mutability: 'IMMUTABLE' });
            return newBlock;
          }
          default:
            return block;
        }
      }
      return block;
    });
    const newContentState = contentState.set('blockMap', newBlockMap);

    return newContentState;
  };

  useEffect(() => {
    let tempImages = [...images];
    //https://github.com/jpuri/draftjs-to-html/issues/18
    // const html = draftjsToHtml(convertToRaw(editorState.getCurrentContent()));
    // const data = draftjsToHtml(convertToRaw(editorState.getCurrentContent()));
    const customEntityTransformFunc = (entity, text) => {
      // console.log('--[entity]-->', entity);
      if (entity.type == 'IMAGE' || entity.type == 'image') {
        if (entity.data?.src?.length > 0) {
          entity.data?.imageId && tempImages.push(entity.data?.imageId);
          // return getCustomComponentString();
          //// eslint-disable-next-line consistent-return</img>`;
          if (entity.data?.width && entity.data?.height) {
            return `<figure><img src="${entity.data.src}"
            width="${entity.data?.width}" 
            height="${entity.data?.height}"
            alt="${text || ''}"
            style="object-fit: contain;"
            /></figure>`;
          }
          return `<figure><img src="${entity.data.src}"
          alt="${text || ''}"
          style="object-fit: contain;"
          /></figure>`;
        }
      }
      return;
    };

    const html = draftjsToHtml(
      convertToRaw(editorState.getCurrentContent()),
      undefined,
      undefined,
      customEntityTransformFunc
    );

    // console.log('-images-->', tempImages);
    // https://raw.githubusercontent.com/facebook/draft-js/master/examples/draft-0-10-0/convertFromHTML/image.png
    // console.log('--[html]-->', html);
    setContents({
      html,
      images: [...new Set(tempImages)],
    });
  }, [editorState]);
  // ----------------------------------------------------------------------------------------------------
  const handleInsertImage = (args) => {
    // const src = prompt('Please enter the URL of your picture');
    const src = args.src;
    const width = args.width;
    const height = args.height;
    const imageId = args.imageId;
    if (!src || width <= 0 || height <= 0) {
      return;
    }

    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity(
      'IMAGE', // 'image'
      'IMMUTABLE',
      { src, width, height, imageId }
      // { src }
    );
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(editorState, {
      currentContent: contentStateWithEntity,
    });
    return setEditorState(
      AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, ' ')
    );
  };

  const handleAddLink = () => {
    const selection = editorState.getSelection();
    const link = prompt('Please enter the URL of your link');
    if (!link) {
      setEditorState(RichUtils.toggleLink(editorState, selection, null));
      return;
    }
    const content = editorState.getCurrentContent();
    const contentWithEntity = content.createEntity('LINK', 'MUTABLE', {
      url: link,
    });
    const newEditorState = EditorState.push(
      editorState,
      contentWithEntity,
      'apply-entity'
    );
    const entityKey = contentWithEntity.getLastCreatedEntityKey();
    setEditorState(RichUtils.toggleLink(newEditorState, selection, entityKey));
  };

  const handleKeyCommand = (command) => {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      setEditorState(newState);
      return 'handled';
    }
    return 'not-handled';
  };

  const handleTogggleClick = (e, inlineStyle) => {
    e.preventDefault();
    setEditorState(RichUtils.toggleInlineStyle(editorState, inlineStyle));
  };

  const handleBlockClick = (e, blockType) => {
    e.preventDefault();
    setEditorState(RichUtils.toggleBlockType(editorState, blockType));
  };
  // ----------------------------------------------------------------------------------------------------

  return (
    <div
      style={{
        ...style,
      }}
    >
      <div
        style={{
          display: 'flex',
          padding: 4,
          background: '#FFFFFF',
          border: '1px solid #DBDADE',
          borderRadius: 4,
        }}
      >
        {/* <Button onClick={(e) => handleBlockClick(e, 'header-one')}>H1</Button> */}
        {/* <Button onClick={(e) => handleBlockClick(e, 'header-two')}>H2</Button> */}
        {/* <Button onClick={(e) => handleBlockClick(e, 'header-three')}>H3</Button> */}
        <Button onClick={(e) => handleBlockClick(e, 'header-three')}>H3</Button>
        <Button onClick={(e) => handleBlockClick(e, 'unstyled')}>N</Button>
        <Button onClick={(e) => handleTogggleClick(e, 'BOLD')}>B</Button>
        <Button onClick={(e) => handleTogggleClick(e, 'ITALIC')}>I</Button>
        <Button onClick={(e) => handleTogggleClick(e, 'UNDERLINE')}>_</Button>
        <Button
          onClick={(e) => handleTogggleClick(e, 'STRIKETHROUGH')}
          icon={
            <img
              width={14}
              height={14}
              src={require('./images/strikethrough.png')}
            />
          }
        />
        <Button
          onClick={(e) => handleBlockClick(e, 'ordered-list-item')}
          icon={
            <img width={24} height={24} src={require('./images/order.png')} />
          }
        />
        <Button
          onClick={(e) => handleBlockClick(e, 'unordered-list-item')}
          icon={
            <img width={24} height={24} src={require('./images/unorder.png')} />
          }
        />
        <Button
          onClick={(e) => {
            e.preventDefault();
            // handleInsertImage();
            setGModal((prev) => {
              return {
                ...prev,
                show: true,
                component: (
                  <ImageModal
                    handleInsertImage={handleInsertImage}
                    {...props}
                  />
                ),
              };
            });
          }}
        >
          image
        </Button>
        {/*
         <Button
          onClick={(e) => {
            e.preventDefault();
            handleInsertImage();
          }}
        >
          image
        </Button>
        <Button
          disabled={editorState.getSelection().isCollapsed()}
          onClick={(e) => {
            e.preventDefault();
            handleAddLink();
          }}
        >
          link
        </Button> 
        <Button
          disabled={editorState.getUndoStack().size <= 0}
          onClick={() => setEditorState(EditorState.undo(editorState))}
        >
          UnDo
        </Button>
        <Button
          disabled={editorState.getRedoStack().size <= 0}
          onClick={() => setEditorState(EditorState.redo(editorState))}
        >
          ReDo
        </Button>
        */}
      </div>
      <div
        style={{
          display: 'flex',
          height: '86%',
          marginTop: '10px',
          padding: '20px',
          border: '1px solid #DBDADE',
          overflow: 'auto',
        }}
        onClick={(e) => {
          editRef?.current?.focus();
        }}
      >
        <Editor
          ref={editRef}
          // placeholder="내용을 작성해주세요."
          editorState={editorState}
          onChange={setEditorState}
          // handleKeyCommand={handleKeyCommand}
          // blockRendererFn={mediaBlockRenderer}
          plugins={[blockDndPlugin, focusPlugin, resizeablePlugin, imagePlugin]}
        />
      </div>
    </div>
  );
};
// export default forwardRef(BaseEditor);
export default BaseEditor;
